module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 251);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/input-number.css");

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/checkbox.css");

/***/ }),

/***/ 122:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/checkbox-group");

/***/ }),

/***/ 13:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/message-box");

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/message.css");

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/checkbox-group.css");

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dialog.css");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/button");

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/tooltip");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dropdown-item");

/***/ }),

/***/ 251:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/sample-dialog/src/index.vue?vue&type=template&id=7d912e35&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c(
        "div",
        { staticClass: "sample-dialog mask", style: { zIndex: _vm.zIndex } },
        [
          _c("div", { staticClass: "inner" }, [
            _c("div", { staticClass: "dialog-header" }, [
              _c("div", { staticClass: "title" }, [
                _c("img", {
                  attrs: { src: `${_vm.appendUrl}sample-logo.png`, alt: "" }
                }),
                _vm._v(" "),
                _vm._m(0)
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "close-icon wj-icon-close",
                on: {
                  click: function($event) {
                    return _vm.$emit("update:visible", false)
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("PackageDetail", {
                  staticClass: "pkgs",
                  attrs: {
                    "active-service": _vm.innerActiveService,
                    "project-type": _vm.projectType,
                    "sample-size": _vm.innerSampleSize,
                    "online-data": _vm.onlineData,
                    "sample-unit-price": _vm.sampleUnitPrice
                  },
                  on: {
                    "update:activeService": function($event) {
                      _vm.innerActiveService = $event
                    },
                    "update:active-service": function($event) {
                      _vm.innerActiveService = $event
                    },
                    "update:sampleSize": function($event) {
                      _vm.innerSampleSize = $event
                    },
                    "update:sample-size": function($event) {
                      _vm.innerSampleSize = $event
                    },
                    getCouponsAndPackage: _vm.getCouponsAndPackage
                  }
                }),
                _vm._v(" "),
                _c("payment", {
                  attrs: {
                    "coupon-list": _vm.coupons,
                    "active-service": _vm.innerActiveService,
                    "sample-size": _vm.innerSampleSize,
                    "online-data": _vm.onlineData,
                    "confirm-zindex": _vm.confirmZindex,
                    "project-question-num": _vm.projectQuestionNum,
                    "sample-unit-price": _vm.sampleUnitPrice,
                    "project-id": _vm.projectId
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dsc" }, [
      _c("span", { staticClass: "font-bold" }, [_vm._v("样本服务")]),
      _vm._v(" "),
      _c("span", { staticClass: "font-lighter" }, [
        _vm._v("已为客户采集 3193 万份商业有效样本")
      ])
    ])
  }
]
render._withStripped = true


// CONCATENATED MODULE: ./packages/sample-dialog/src/index.vue?vue&type=template&id=7d912e35&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/message.css"
var message_css_ = __webpack_require__(14);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/message"
var message_ = __webpack_require__(3);
var message_default = /*#__PURE__*/__webpack_require__.n(message_);

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(1);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// CONCATENATED MODULE: ./src/http/vue-sample-dialog/index.js

let request = external_vue_default.a.prototype.commonRequest;
if (!request || !request.get || !request.post) {
  console.log("%c项目没有注入http封装", "color:red;");
}

/**
 * 获取订单支付状态
 * @param {string} order_id
 */
function payOrderStatus(order_id) {
  request = external_vue_default.a.prototype.commonRequest;
  return request.post("/member/api/validate_payorder/", {
    order_id
  });
}

/**
 * 购买弹窗立即支付按钮 生成支付订单
 * @returns
 */
function createOrder(params) {
  request = external_vue_default.a.prototype.commonRequest;
  return request.post("/api/order/create/", {
    ...params
  });
}

/**
 * @method 有偿收集
 */
function httpPostPaidcollect(params) {
  request = external_vue_default.a.prototype.commonRequest;
  return request.post("/pconvert/api/pconvert_paid/", {
    ...params
  });
}

/**
 * @method  验证发起样本服务状态
 */
function httpGetSampleService(pid, params) {
  request = external_vue_default.a.prototype.commonRequest;
  return request.get(`/common/api/publish_sample_service_status/${pid}/`, params);
}

/**
 * @method 获取优惠券列表
 */
function httpGetCouponList(params) {
  request = external_vue_default.a.prototype.commonRequest;
  return request.get("/pconvert/api/get_coupon_list/", params);
}

// 获取 payorderid
function memberPayorderApi() {
  let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  request = external_vue_default.a.prototype.commonRequest;
  params.redErrorMsg = true;
  return request.post(`/member/api/payorder/`, params);
}

// 验证支付
function validatePayorderApi() {
  let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  request = external_vue_default.a.prototype.commonRequest;
  params.redErrorMsg = true;
  return request.post(`/member/api/validate_payorder/`, params);
}

// 获取支付跳转链接
function payredirect() {
  let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  request = external_vue_default.a.prototype.commonRequest;
  return request.get(`/member/api/payredirect/`, params);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/sample-dialog/src/payment.vue?vue&type=template&id=403882a6&scoped=true&
var paymentvue_type_template_id_403882a6_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "package-payment" },
    [
      _vm.activeService == "person-service"
        ? _c("div", { staticClass: "artificial" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v("\n            获取优惠报价\n        ")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "service-info member-info" }, [
                _c("span", [_vm._v("样本顾问")]),
                _c("span", [_vm._v(_vm._s(_vm.onlineData.name))])
              ]),
              _vm._v(" "),
              _c("img", { attrs: { src: _vm.onlineData.qrCode, alt: "" } }),
              _vm._v(" "),
              _vm._m(0),
              _vm._v(" "),
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "service-info phone-info" }, [
                _c("span", [_vm._v("电话联系")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.onlineData.phone))])
              ])
            ])
          ])
        : _c("div", { staticClass: "dis-artificial" }, [
            _c("div", { staticClass: "cost" }, [
              _c("span", { staticClass: "symbol" }, [_vm._v("￥")]),
              _vm._v(" "),
              _c("span", { staticClass: "price" }, [
                _vm._v(_vm._s(_vm.sampleRealPrice))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("div", { staticClass: "item-price info-item" }, [
                _c("span", [_vm._v("实付单价（每样本）")]),
                _vm._v(" "),
                _c("span", [
                  _vm._v("约" + _vm._s(_vm.sampleRealUnitPrice) + "元")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "hr" }),
              _vm._v(" "),
              _c("div", { staticClass: "total-price info-item font-bold" }, [
                _c("span", [_vm._v("样本总价")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.sampleTotalPrice) + "元")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "total-detail font-lighter" }, [
                _c("div", { staticClass: "item-price info-item" }, [
                  _c("span", [
                    _vm._v(
                      "基础单价（" + _vm._s(_vm.projectQuestionNum) + "题）"
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.sampleUnitPrice) + "元")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "total-num info-item" }, [
                  _c("span", [_vm._v("回收数量")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("×" + _vm._s(_vm.sampleSize))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "discount info-item font-lighter" }, [
                _c(
                  "div",
                  { staticClass: "tooltip" },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.activeService == "sale-sample"
                            ? "限时补贴"
                            : "多订折扣"
                        )
                      )
                    ]),
                    _c(
                      "wd-tooltip",
                      { attrs: { placement: "top", effect: "light" } },
                      [
                        _c("img", {
                          staticClass: "icon-help",
                          attrs: { src: _vm.IconQuestion }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.tooltipText) +
                                "\n                        "
                            )
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", [_vm._v("-" + _vm._s(_vm.sampleDiscount) + "元")])
              ]),
              _vm._v(" "),
              _vm.avaliableCoupons.length > 0
                ? _c(
                    "div",
                    { staticClass: "coupon info-item font-lighter" },
                    [
                      _c(
                        "wd-dropdown",
                        {
                          attrs: { trigger: "click" },
                          on: { command: _vm.selectCoupon }
                        },
                        [
                          _c("div", { staticClass: "coupon" }, [
                            _c("span", [
                              _vm._v("\n                            优惠券"),
                              _c("i", { staticClass: "wd-icon-caret-bottom" })
                            ]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v("-" + _vm._s(_vm.couponDeduction) + "元")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "wd-dropdown-menu",
                            { attrs: { slot: "dropdown" }, slot: "dropdown" },
                            _vm._l(_vm.avaliableCoupons, function(coupon, i) {
                              return _c(
                                "wd-dropdown-item",
                                {
                                  key: `coupon-${i}`,
                                  attrs: { command: coupon }
                                },
                                [
                                  _c("span", [_vm._v("优惠券")]),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v("-" + _vm._s(coupon.value) + "元")
                                  ])
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actual-delivery info-item font-bold" },
                [
                  _c("span", [_vm._v("实际支付")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.sampleRealPrice) + "元")])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "pay-area" }, [
              _c("button", {
                staticClass: "pay_way alipay",
                class: { inactive: _vm.payWay === "wechatpay" },
                on: {
                  click: function($event) {
                    return _vm.changePayWay("alipay")
                  }
                }
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "pay_way wechat",
                class: { inactive: _vm.payWay === "alipay" },
                on: {
                  click: function($event) {
                    return _vm.changePayWay("wechatpay")
                  }
                }
              })
            ])
          ]),
      _vm._v(" "),
      _c(
        "wd-button",
        {
          staticClass: "submit",
          attrs: { type: "primary" },
          on: { click: _vm.sampleOrder }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.activeService == "person-service" ? "登记需求" : "立即下单"
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "tip" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.activeService == "person-service"
                ? "下单有优惠，欢迎联系我"
                : "现在下单预计 3 天完成收集"
            ) +
            "\n    "
        )
      ])
    ],
    1
  )
}
var paymentvue_type_template_id_403882a6_scoped_true_staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-info skill-info" }, [
      _c("span", [_vm._v("专业能力")]),
      _vm._v(" "),
      _c("span", [_vm._v("录入/检查/清洗/交付")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "service-info skill-info" }, [
      _c("span", [_vm._v("有效交付")]),
      _vm._v(" "),
      _c("span", [_vm._v("400+项目")])
    ])
  }
]
paymentvue_type_template_id_403882a6_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/sample-dialog/src/payment.vue?vue&type=template&id=403882a6&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/message-box.css"
var message_box_css_ = __webpack_require__(33);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/message-box"
var message_box_ = __webpack_require__(13);
var message_box_default = /*#__PURE__*/__webpack_require__.n(message_box_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dropdown-item.css"
var dropdown_item_css_ = __webpack_require__(55);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dropdown-item"
var dropdown_item_ = __webpack_require__(25);
var dropdown_item_default = /*#__PURE__*/__webpack_require__.n(dropdown_item_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dropdown-menu.css"
var dropdown_menu_css_ = __webpack_require__(56);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dropdown-menu"
var dropdown_menu_ = __webpack_require__(26);
var dropdown_menu_default = /*#__PURE__*/__webpack_require__.n(dropdown_menu_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dropdown.css"
var dropdown_css_ = __webpack_require__(57);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dropdown"
var dropdown_ = __webpack_require__(27);
var dropdown_default = /*#__PURE__*/__webpack_require__.n(dropdown_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/tooltip.css"
var tooltip_css_ = __webpack_require__(39);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/tooltip"
var tooltip_ = __webpack_require__(20);
var tooltip_default = /*#__PURE__*/__webpack_require__.n(tooltip_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/button.css"
var button_css_ = __webpack_require__(8);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/button"
var button_ = __webpack_require__(2);
var button_default = /*#__PURE__*/__webpack_require__.n(button_);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/sample-dialog/src/payment.vue?vue&type=script&lang=js&















/* harmony default export */ var paymentvue_type_script_lang_js_ = ({
  components: {
    [button_default.a.name]: button_default.a,
    [tooltip_default.a.name]: tooltip_default.a,
    [dropdown_default.a.name]: dropdown_default.a,
    [dropdown_menu_default.a.name]: dropdown_menu_default.a,
    [dropdown_item_default.a.name]: dropdown_item_default.a
  },
  props: {
    // 项目id
    projectId: {
      type: String,
      default: ""
    },
    // 支付的套餐优惠券列表
    couponList: {
      type: Array,
      default: () => []
    },
    // 选择的样本服务类型
    activeService: {
      type: String,
      default: "person-service"
    },
    // 样本顾问信息
    onlineData: {
      type: Object,
      default: () => {}
    },
    // 回收数量
    sampleSize: {
      type: Number,
      default: 50
    },
    // 非复杂项目题目数量
    projectQuestionNum: {
      type: Number,
      default: 1
    },
    // 最高级解决层级问题，手动解决层级问题
    confirmZindex: {
      type: Number,
      default: null
    },
    // 样本单价
    sampleUnitPrice: {
      type: Number,
      default: 3
    }
  },
  data() {
    return {
      payWay: "alipay",
      IconQuestion: `//s1.wenjuan.com/assets/images/business/package-dialog/question.png`,
      checkedCoupon: null,
      orderId: "" // 订单ID
    };
  },

  computed: {
    // 多订折扣文案
    tooltipText() {
      return this.activeService == "sale-sample" ? "题目数15题及以下，限时补贴3折优惠" : "满100打9折，满200打8折，满300打7折，满500打6折";
    },
    // 样本总价
    sampleTotalPrice() {
      return this.sampleUnitPrice * this.sampleSize;
    },
    // 限时补贴/多订折扣
    sampleDiscount() {
      if (this.activeService == "sale-sample") {
        return (this.sampleTotalPrice * 0.7).toFixed(2);
      }
      return this.calculateDiscount(this.sampleSize, this.sampleTotalPrice);
    },
    // 实际支付-未使用优惠券
    sampleOriginPrice() {
      return (this.sampleTotalPrice - this.sampleDiscount).toFixed(2) || 0;
    },
    // 优惠券有使用门槛，支付金额(除优惠券以外的部分)必须大于等于优惠券最低门槛价格
    avaliableCoupons() {
      return this.couponList.filter(v => {
        const satisfyV = Number.isNaN(Number.parseFloat(v.satisfy_value)) ? 0 : Number.parseFloat(v.satisfy_value);
        return this.sampleOriginPrice >= satisfyV;
      });
    },
    // 选中的优惠券面额
    couponDeduction() {
      var _this$checkedCoupon;
      return (_this$checkedCoupon = this.checkedCoupon) === null || _this$checkedCoupon === void 0 ? void 0 : _this$checkedCoupon.value;
    },
    // 实际支付-使用优惠券后
    sampleRealPrice() {
      return Math.max(this.sampleOriginPrice - this.couponDeduction, 0).toFixed(2);
    },
    // 实付单价
    sampleRealUnitPrice() {
      return (this.sampleRealPrice / this.sampleSize).toFixed(2);
    },
    // 预计时间
    predictTime() {
      const conditionTime = 0;
      const totolTime = Math.ceil((0.9 + conditionTime) * this.sampleSize / 100);
      return totolTime < 2 ? 2 : totolTime;
    }
  },
  watch: {
    // 优惠券列表更新时 默认选中优惠券的规则
    avaliableCoupons: {
      handler(v) {
        if (v.length > 0) {
          let minPlusDiff = Infinity;
          let minMinusDiff = Infinity;
          let selectedCoupon;
          // eslint-disable-next-line no-restricted-syntax
          for (const coupon of v) {
            // 计算实际支付与优惠券差值的绝对值
            const diff = coupon.value - this.sampleOriginPrice;
            // 优惠券数值相等直接选中
            if (diff === 0) {
              selectedCoupon = coupon;
              break;
            }
            // 优惠券大于实付
            if (diff > 0 && diff < minPlusDiff) {
              minPlusDiff = diff;
              selectedCoupon = coupon;
            }
            // 优惠券小于实付 已有大于实付优惠券时 不考虑
            if (diff < 0 && Math.abs(diff) < minMinusDiff && minPlusDiff === Infinity) {
              minMinusDiff = Math.abs(diff);
              selectedCoupon = coupon;
            }
          }
          this.selectCoupon(selectedCoupon);
        } else {
          this.selectCoupon({
            value: 0,
            oid: ""
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    // 修改支付方式
    changePayWay(payWay) {
      this.payWay = payWay;
    },
    // 选择优惠券
    selectCoupon(v) {
      console.log("选中的优惠券", v, this.avaliableCoupons);
      const selectedCoupon = this.avaliableCoupons.length && v.value && this.avaliableCoupons.filter(item => item.value == v.value).reduce((minCoupon, curCoupon) => {
        // 过期时间不同 取先过期的
        if (new Date(curCoupon === null || curCoupon === void 0 ? void 0 : curCoupon.expire_date).getTime() < new Date(minCoupon.expire_date).getTime()) {
          return curCoupon;
        }
        // 过期时间相同 取先发放的
        if (new Date(curCoupon === null || curCoupon === void 0 ? void 0 : curCoupon.expire_date).getTime() == new Date(minCoupon.expire_date).getTime()) {
          return new Date(curCoupon === null || curCoupon === void 0 ? void 0 : curCoupon.from_date).getTime() < new Date(minCoupon.from_date).getTime() ? curCoupon : minCoupon;
        }
        return minCoupon;
      });
      console.log("最终使用的优惠券", selectedCoupon);
      this.checkedCoupon = selectedCoupon || v;
    },
    // 登记需求和下单按钮
    async sampleOrder() {
      if (this.activeService === "accurate-sample") {
        if (this.sampleOrder.user) return;
        this.sampleOrder.user = true;
        setTimeout(() => {
          this.sampleOrder.user = false;
        }, 200);
        let checkPamentTicker = null;

        // 样本服务商品ID
        const packageGoodsIdList = {
          3: this.activeService === "sale-sample" ? "66150752594373454648867d" : "66150752594373454648867e",
          6: "66150752594373454648867f",
          9: "661507525943734546488680"
        };
        try {
          var _res$data, _res$data2, _res$data3, _res$data5;
          const params = {
            order_attach: {
              discount_price: ((Number(this.sampleDiscount) + Number(this.couponDeduction)) * 100).toFixed() - 0,
              // 优惠的金额（包括优惠券）
              single_price: (Number(this.sampleRealUnitPrice) * 100).toFixed() - 0,
              // 单位样本的实付单价
              project_id: this.projectId,
              // 项目id
              collection_num: this.sampleSize,
              // 样本数量
              consultant_name: this.onlineData.realname // 样本顾问名称
            },

            cargo_to_buy: [{
              goods_id: packageGoodsIdList[this.sampleUnitPrice],
              amount: this.sampleSize
            }],
            payment_info: [{
              pay_channel: ["alipay", "wechatpay"].indexOf(this.payWay) + 1,
              cent_to_pay: (this.sampleRealPrice * 100).toFixed() - 0
            }],
            coupon_to_use: this.checkedCoupon.oid ? [this.checkedCoupon.oid] : []
          };
          const res = await createOrder(params);
          if (!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.is_success)) return Promise.reject(new Error("checkPayment faild."));

          // 使用优惠券实际支付金额小于等于0时且购买成功时 不返回order_id
          if (!((_res$data2 = res.data) !== null && _res$data2 !== void 0 && _res$data2.order_id)) {
            this.afterPayment(true);
            return;
          }

          // 接口返回pay_redirect_url 新开支付页面
          ((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.pay_redirect_url) && window.open(res.data.pay_redirect_url, "_blank");

          // // 开启轮询，只是为了保证二次确认弹窗还在的时候，用户支付成功，自动关闭弹窗
          // // 一旦二次确认弹窗关闭（无论点击确定还是取消），都会取消轮询
          checkPamentTicker = setInterval(async () => {
            try {
              var _res$data4;
              console.log("在轮询检查支付状态");
              await this.checkPayment((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.order_id);
              // 如果轮询检查支付成功，关闭轮询，关闭弹窗
              clearInterval(checkPamentTicker);
              // 手动关闭支付确认弹窗
              message_box_default.a.close();
              this.afterPayment(true);
            } catch (error) {
              //
            }
          }, 3000);
          await message_box_default.a.confirm("支付完成前，请勿关闭此窗口<br />支付完成后，请根据支付情况点击以下按钮", "支付成功确认", {
            confirmButtonText: "支付成功",
            closeOnPressEscape: false,
            dangerouslyUseHTMLString: true,
            ...(this.confirmZindex || this.zIndex ? {
              zIndex: this.confirmZindex || this.zIndex + 1
            } : null)
          });
          await this.checkPayment((_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.order_id);
          this.afterPayment(true);
        } catch (error) {
          // 支付过程中产生的所有错误，不包括用户取消支付确认
          console.log(error);
          if (error !== "cancel") {
            this.afterPayment(false);
          }
        }
        // 只要用户操作了二次确认弹窗，弹窗关闭后，则关闭轮询
        clearInterval(checkPamentTicker);
      } else if (this.activeService === "sale-sample") {
        this.handlePay();
      } else {
        window.open(this.onlineData.register);
      }
    },
    // 检查订单是否支付成功，如果成功则购买，否则返回错误
    async checkPayment(order_id) {
      try {
        const {
          data
        } = await payOrderStatus(order_id);
        if ((data === null || data === void 0 ? void 0 : data.order_status) === 1) {
          console.log("购买成功");
          return true;
        }
        return Promise.reject(new Error("checkPayment faild."));
      } catch (error) {
        return Promise.reject(error);
      }
    },
    // 支付之后
    afterPayment() {
      let successful = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (successful) {
        message_default()({
          message: "支付成功",
          type: "success"
        });
        // 关闭弹窗事件
        this.$parent.$emit("update:visible", false);
        // 购买流程结束事件
        this.$parent.$emit("payment", true);
        if (this.$parent.needReload) {
          window.location.reload();
        }
      } else {
        message_default()({
          message: "您未完成支付",
          type: "warning"
        });
        this.$parent.$emit("payment", false);
      }
    },
    // 多订折扣
    calculateDiscount(size, price) {
      const discounts = [{
        threshold: 500,
        discount: 0.6
      }, {
        threshold: 300,
        discount: 0.7
      }, {
        threshold: 200,
        discount: 0.8
      }, {
        threshold: 100,
        discount: 0.9
      }];
      for (let i = 0; i < discounts.length; i++) {
        if (size >= discounts[i].threshold) {
          const discountedPrice = (price * (1 - discounts[i].discount)).toFixed(2);
          return discountedPrice;
        }
      }
      return 0;
    },
    // 特价样本支付走老的逻辑
    async handlePay() {
      try {
        // 检测项目是否变化
        const isChange = await this.sugesstDialogInfo();
        if (isChange) {
          message_box_default.a.confirm("检测到该项目发生了变更，请您重新下单", "提示", {
            showCancelButton: false,
            confirmButtonText: "确定"
          }).then(() => {
            this.handleReload();
          }).catch(error => {
            console.log(error);
          });
          return;
        }
        this.paymentSubmit();
      } catch (error) {
        console.log(error);
      }
    },
    async sugesstDialogInfo() {
      try {
        const res = await httpGetSampleService(this.projectId, {
          check_type: "sample"
        });
        if (res.status === 200 && res.status_code === 1) {
          const backData = res.data;
          const checkFiled = ["answer_end_early", "begin_finish_date", "force_get_weixinuserinfo_btn", "is_email_rspd_only", "asw_white_list", "password", "quality_control", "restrict_mobile_rspd", "survey_count", "question_edit", "restrict_email_rspd", "restrict_weixin_rspd", "restrict_dingding_rspd", "restrict_wxwork_rspd", "restrict_feishu_rspd"];
          const isChange = checkFiled.some(item => backData[item] === true);
          return isChange;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 一键刷新
    handleReload() {
      sessionStorage.setItem("projectCollectType", "GeneralCollect");
      // 刷新页面
      location.reload();
    },
    // 支付
    async paymentSubmit() {
      let tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (this.sampleRealPrice > 0 && tag) {
        console.log("调起第三方支付");
        this.getMemberPayorder();
      } else {
        console.log("直接支付");
        try {
          const params = {
            act: "comfirm_order",
            pid: this.projectId,
            sample_type: 1,
            estimated_collection_time: this.predictTime,
            community_info_list: []
          };
          const communityInfo = {
            community_name: "答题人群",
            person_num: this.sampleSize,
            feature_en_name_list: [],
            features_cost: 0.9
          };
          params.community_info_list.push(communityInfo);
          if (this.couponDeduction) {
            params.c_id = this.checkedCoupon.oid;
            params.c_type = this.checkedCoupon.c_type;
          }
          const res = await httpPostPaidcollect(params);
          if (res.status === 200 && res.status_code === 1 && res.data.success) {
            this.afterPayment(true);
          }
          // 提交订单数据
        } catch (error) {
          console.log(error);
        }
      }
    },
    // 获取第三方支付的payorder
    getMemberPayorder() {
      memberPayorderApi({
        amount_cent: (this.sampleRealPrice * 100).toFixed() - 0,
        pay_channel: this.payWay
      }).then(res => {
        this.orderId = res.data.order_id;
        this.getPayredirect(res.data.order_id);
      }).catch(() => {});
    },
    // 第三方支付是否成功验证
    async validatePayorder(order_id) {
      try {
        const {
          data
        } = await validatePayorderApi({
          order_id
        });
        if ((data === null || data === void 0 ? void 0 : data.order_status) === 1) {
          console.log("购买成功");
          await this.paymentSubmit(false);
          return true;
        }
        return Promise.reject(new Error("checkPayment faild."));
      } catch (error) {
        console.log("there");
        return Promise.reject(error);
      }
    },
    // 获取支付跳转链接
    async getPayredirect(orderId) {
      let checkPamentTickerSale;
      try {
        var _res$data6;
        const res = await payredirect({
          order_id: orderId
        });

        // 接口返回pay_redirect_url 新开支付页面
        ((_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.redirect_to) && window.open(res.data.redirect_to, "_blank");

        // 开启轮询，只是为了保证二次确认弹窗还在的时候，用户支付成功，自动关闭弹窗
        // // 一旦二次确认弹窗关闭（无论点击确定还是取消），都会取消轮询
        checkPamentTickerSale = setInterval(async () => {
          try {
            console.log("在轮询检查支付状态-特价样本");
            await this.validatePayorder(orderId);
            // 如果轮询检查支付成功，关闭轮询，关闭弹窗
            clearInterval(checkPamentTickerSale);
            // 手动关闭支付确认弹窗
            message_box_default.a.close();
            this.afterPayment(true);
          } catch (error) {
            // console.log(error);
          }
        }, 3000);
        await message_box_default.a.confirm("支付完成前，请勿关闭此窗口<br />支付完成后，请根据支付情况点击以下按钮", "支付成功确认", {
          confirmButtonText: "支付成功",
          closeOnPressEscape: false,
          dangerouslyUseHTMLString: true,
          ...(this.confirmZindex || this.zIndex ? {
            zIndex: this.confirmZindex || this.zIndex + 1
          } : null)
        });
        await this.validatePayorder(orderId);
      } catch (error) {
        // 支付过程中产生的所有错误，不包括用户取消支付确认
        if (error !== "cancel") {
          this.afterPayment(false);
        }
        console.log("payment errors: ", error);
      }
      clearInterval(checkPamentTickerSale);
    }
  }
});
// CONCATENATED MODULE: ./packages/sample-dialog/src/payment.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_paymentvue_type_script_lang_js_ = (paymentvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/sample-dialog/src/payment.vue?vue&type=style&index=0&id=403882a6&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/sample-dialog/src/payment.vue?vue&type=style&index=0&id=403882a6&prod&lang=scss&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(0);

// CONCATENATED MODULE: ./packages/sample-dialog/src/payment.vue






/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_paymentvue_type_script_lang_js_,
  paymentvue_type_template_id_403882a6_scoped_true_render,
  paymentvue_type_template_id_403882a6_scoped_true_staticRenderFns,
  false,
  null,
  "403882a6",
  null
  
)

/* harmony default export */ var payment = (component.exports);
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--5!./node_modules/vue-loader/lib??vue-loader-options!./packages/sample-dialog/src/package-detail.vue?vue&type=template&id=3276abc8&scoped=true&
var package_detailvue_type_template_id_3276abc8_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "package-detail" },
    [
      _c(
        "ul",
        { staticClass: "tabs", class: _vm.borderStyle ? "left" : "right" },
        [
          _vm._l(_vm.showServiceList, function(item) {
            return _c(
              "li",
              {
                key: item.key,
                staticClass: "tab",
                on: {
                  click: function($event) {
                    return _vm.changeService(item)
                  }
                }
              },
              [
                _c("h3", { staticClass: "name" }, [_vm._v(_vm._s(item.name))]),
                _vm._v(" "),
                _c("p", { staticClass: "intro" }, [_vm._v(_vm._s(item.intro))])
              ]
            )
          }),
          _vm._v(" "),
          _vm.showServiceList.length == 1
            ? _c("li", { staticStyle: { width: "300px" } })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "detail-part" }, [
        _c(
          "ul",
          {
            staticClass: "amount-part",
            class: _vm.borderStyle ? "right" : "left"
          },
          _vm._l(_vm.samplePackageList, function(item, index) {
            return _c(
              "li",
              {
                key: item.goods_id,
                class:
                  _vm.activePackge.goods_id == item.goods_id
                    ? "active-part"
                    : "",
                on: {
                  click: function($event) {
                    return _vm.changeCount(item.sampleSize, index)
                  }
                }
              },
              [
                _c("div", { staticClass: "total" }, [
                  _vm._v(_vm._s(item.info))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "price" }, [
                  item.price
                    ? _c("div", { staticClass: "real-price" }, [
                        _vm._v("\n                        ￥"),
                        _c("span", [_vm._v(_vm._s(item.price))]),
                        _vm._v(" 起\n                    ")
                      ])
                    : _vm.activeService == "accurate-sample" && index != 3
                    ? _c("div", [
                        _c("div", { staticClass: "real-price" }, [
                          _vm._v("\n                            ￥"),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                (
                                  _vm.sampleUnitPrice *
                                  Number(item.sampleSize) *
                                  item.discount
                                ).toFixed()
                              )
                            )
                          ]),
                          _vm._v(
                            "\n                            起\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        item.discount && index != 0
                          ? _c("div", { staticClass: "discount" }, [
                              _vm._v("\n                            ￥"),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    (
                                      _vm.sampleUnitPrice *
                                      Number(item.sampleSize)
                                    ).toFixed()
                                  )
                                )
                              ]),
                              _vm._v(
                                "\n                            起\n                        "
                              )
                            ])
                          : _vm._e()
                      ])
                    : _c(
                        "div",
                        {
                          on: {
                            click: function($event) {
                              return _vm.changeCusromSize($event)
                            }
                          }
                        },
                        [
                          _c("wd-input-number", {
                            attrs: {
                              "controls-position": "right",
                              "custom-error-tip": _vm.customErrorTips,
                              "hide-error-message": true,
                              min: 50,
                              max: 99999,
                              label: "描述文字"
                            },
                            on: { change: _vm.changeCusromSize },
                            model: {
                              value: _vm.customSize,
                              callback: function($$v) {
                                _vm.customSize = $$v
                              },
                              expression: "customSize"
                            }
                          })
                        ],
                        1
                      )
                ]),
                _vm._v(" "),
                item.dsc
                  ? _c("div", { staticClass: "intro" }, [
                      _vm._v(_vm._s(item.dsc))
                    ])
                  : _c("div", { staticClass: "intro" }, [
                      _vm._v(_vm._s(_vm.AISamplePackageDsc))
                    ])
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "service-detail-part" }, [
          _c("div", { staticClass: "title" }, [_vm._v("服务详情")]),
          _vm._v(" "),
          _vm.activeService == "person-service"
            ? _c("div", { staticClass: "detail" }, [
                _c("div", { staticClass: "service-detail left-detail" }, [
                  _c("div", { staticClass: "service-header" }, [
                    _c("img", {
                      attrs: { src: `${_vm.appendUrl}account.png`, alt: "" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "service-title" }, [
                      _vm._v("收集定制")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "service-intro" }, [
                    _vm._v(
                      "\n                        人群标签定制，城市、年龄、职业、收入、兴趣等；样本配额定制\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "service-detail right-detail" }, [
                  _c("div", { staticClass: "service-header" }, [
                    _c("img", {
                      attrs: { src: `${_vm.appendUrl}group.png`, alt: "" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "service-title" }, [
                      _vm._v("样本清洗")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "service-intro" }, [
                    _vm._v(
                      "\n                        数据人工审核，有效样本才收费\n                    "
                    )
                  ])
                ])
              ])
            : _c("div", { staticClass: "detail" }, [
                _c("div", { staticClass: "service-detail service-check" }, [
                  _c("div", { staticClass: "service-header" }, [
                    _c("img", {
                      attrs: { src: `${_vm.appendUrl}account.png`, alt: "" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "service-title" }, [
                      _vm._v("人群要求")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "wd-checkbox-group",
                        {
                          attrs: { size: "medium", horizontal: "" },
                          model: {
                            value: _vm.check1,
                            callback: function($$v) {
                              _vm.check1 = $$v
                            },
                            expression: "check1"
                          }
                        },
                        [
                          _c("wd-checkbox", { attrs: { label: "没有要求" } }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "check-change",
                              on: { click: _vm.changeCheck }
                            },
                            [
                              _c("wd-checkbox", {
                                staticClass: "dis-click",
                                attrs: { label: "特殊要求" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "service-detail service-check" }, [
                  _c("div", { staticClass: "service-header" }, [
                    _c("img", {
                      attrs: { src: `${_vm.appendUrl}group.png`, alt: "" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "service-title" }, [
                      _vm._v("样本清洗")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "wd-checkbox-group",
                        {
                          attrs: { size: "medium", horizontal: "" },
                          model: {
                            value: _vm.check2,
                            callback: function($$v) {
                              _vm.check2 = $$v
                            },
                            expression: "check2"
                          }
                        },
                        [
                          _c("wd-checkbox", { attrs: { label: "自我清洗" } }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "check-change",
                              on: { click: _vm.changeCheck }
                            },
                            [
                              _c("wd-checkbox", {
                                attrs: { label: "委托清洗" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "utils" }, [
          _c(
            "div",
            {
              staticClass: "contact-service",
              on: {
                click: function($event) {
                  _vm.serviceShow = true
                }
              }
            },
            [
              _c("span", { staticClass: "service-icon" }),
              _vm._v(" "),
              _c("span", [_vm._v("联系样本顾问")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "contact-service",
              on: { click: _vm.goSampleIntroduce }
            },
            [
              _c("span", { staticClass: "sample-icon" }),
              _vm._v(" "),
              _c("span", [_vm._v("查看样本介绍")])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "wd-dialog",
        {
          staticClass: "contact-service-counselor",
          attrs: {
            title: "专属样本顾问",
            visible: _vm.serviceShow,
            "show-close": false,
            width: "280px",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.serviceShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "content-contact" }, [
            _c("p", { staticClass: "line-title" }, [_vm._v("电话联系")]),
            _vm._v(" "),
            _c("p", { staticClass: "phone" }, [
              _vm._v(_vm._s(_vm.onlineData.phone))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "line-title" }, [_vm._v("微信联系")]),
            _vm._v(" "),
            _c("img", {
              staticClass: "wx-ercode",
              attrs: { src: _vm.onlineData.qrCode, alt: "服务顾问" }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "ok-btn",
                on: {
                  click: function($event) {
                    _vm.serviceShow = false
                  }
                }
              },
              [_vm._v("\n                好的\n            ")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var package_detailvue_type_template_id_3276abc8_scoped_true_staticRenderFns = []
package_detailvue_type_template_id_3276abc8_scoped_true_render._withStripped = true


// CONCATENATED MODULE: ./packages/sample-dialog/src/package-detail.vue?vue&type=template&id=3276abc8&scoped=true&

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/checkbox.css"
var checkbox_css_ = __webpack_require__(118);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/checkbox"
var checkbox_ = __webpack_require__(50);
var checkbox_default = /*#__PURE__*/__webpack_require__.n(checkbox_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/checkbox-group.css"
var checkbox_group_css_ = __webpack_require__(148);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/checkbox-group"
var checkbox_group_ = __webpack_require__(122);
var checkbox_group_default = /*#__PURE__*/__webpack_require__.n(checkbox_group_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/input-number.css"
var input_number_css_ = __webpack_require__(113);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/input-number"
var input_number_ = __webpack_require__(42);
var input_number_default = /*#__PURE__*/__webpack_require__.n(input_number_);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/theme-chalk/dialog.css"
var dialog_css_ = __webpack_require__(15);

// EXTERNAL MODULE: external "@wenjuan/ui2/lib/dialog"
var dialog_ = __webpack_require__(7);
var dialog_default = /*#__PURE__*/__webpack_require__.n(dialog_);

// CONCATENATED MODULE: ./src/assets/js/vue-sample-dialog/info-config.js
// 样本服务TAB
// 1 复杂项目 只展示人工服务
// 2 非复杂项目 项目题目数在15题及以下，则该项目则为特价样本服务与人工服务
// 3 非复杂项目 当题目数在15题以上后，则为精准样本服务，价格区别如下
const sampleServiceList = [{
  name: "特价样本",
  key: "sale-sample",
  intro: "价格低至每样本0.9元",
  show: ["sale-sample"]
}, {
  name: "精准样本服务",
  key: "accurate-sample",
  intro: "样本顾问协助筛查，收集多有折扣",
  show: ["accurate-sample"]
}, {
  name: "人工服务",
  key: "person-service",
  intro: "免费清洗 / 有效样本才收费",
  show: ["sale-sample", "accurate-sample", "person-service"]
}];
const AISamplePackageList = [{
  goods_id: 1,
  info: "50份 有效样本",
  sampleSize: 50,
  price: 150,
  dsc: "体验样本服务"
}, {
  goods_id: 2,
  info: "200份 有效样本",
  sampleSize: 200,
  price: 480,
  dsc: "补充有效样本"
}, {
  goods_id: 3,
  info: "300份 有效样本",
  sampleSize: 300,
  price: 630,
  dsc: "科学的样本数据"
}, {
  goods_id: 4,
  sampleSize: 500,
  info: "自定义 有效样本"
}];
const saleSamplePackageList = [{
  goods_id: 1,
  info: "50份",
  sampleSize: 50,
  price: 45,
  dsc: "体验样本服务"
}, {
  goods_id: 2,
  info: "300份",
  sampleSize: 300,
  price: 270,
  dsc: "科学的样本数据"
}, {
  goods_id: 3,
  info: "500份",
  sampleSize: 500,
  price: 450,
  dsc: "留有余量适合清洗"
}, {
  goods_id: 4,
  info: "自定义",
  sampleSize: 600,
  dsc: "需要多少收多少"
}];
const accurateSamplePackageList = [{
  goods_id: 1,
  info: "50份",
  sampleSize: 50,
  discount: 1,
  dsc: "体验样本服务"
}, {
  goods_id: 2,
  info: "300份",
  sampleSize: 300,
  discount: 0.7,
  dsc: "科学的样本数据"
}, {
  goods_id: 3,
  info: "500份",
  sampleSize: 500,
  discount: 0.6,
  dsc: "留有余量适合清洗"
}, {
  goods_id: 4,
  info: "自定义",
  sampleSize: 600,
  dsc: "需要多少收多少"
}];
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/sample-dialog/src/package-detail.vue?vue&type=script&lang=js&











/* harmony default export */ var package_detailvue_type_script_lang_js_ = ({
  name: "PackageDetail",
  components: {
    "wd-dialog": dialog_default.a,
    "wd-input-number": input_number_default.a,
    "wd-checkbox-group": checkbox_group_default.a,
    "wd-checkbox": checkbox_default.a
  },
  props: {
    // 项目类型
    projectType: {
      type: [Number, String],
      default: "person-service"
    },
    // 当前高亮样本服务类型
    activeService: {
      type: String,
      default: ""
    },
    // 当前样本购买数量
    sampleSize: {
      type: Number,
      default: 50
    },
    // 样本服务顾问信息
    onlineData: {
      type: Object,
      default: () => {}
    },
    // 样本单价
    sampleUnitPrice: {
      type: Number,
      default: 3
    }
  },
  data() {
    const appendUrl = this.$parent.appendUrl || "";
    return {
      appendUrl,
      serviceShow: false,
      // 服务顾问弹框显隐
      check1: ["没有要求"],
      check2: ["自我清洗"],
      customErrorTips: "50~99999",
      customSize: 50
    };
  },
  computed: {
    // 展示的样本服务列表
    showServiceList() {
      const showServiceList = sampleServiceList.filter(item => item.show.includes(this.projectType));
      return showServiceList;
    },
    // 样本套餐包列表
    samplePackageList() {
      const packageList = {
        "person-service": AISamplePackageList,
        "sale-sample": saleSamplePackageList,
        "accurate-sample": accurateSamplePackageList
      };
      return packageList[this.activeService];
    },
    // 人工服务 自定义有效样本对应的介绍文案
    AISamplePackageDsc() {
      const priceRanges = [{
        min: 50,
        max: 99,
        discount: 1,
        text: "无折扣"
      }, {
        min: 100,
        max: 199,
        discount: 0.9,
        text: "享9折优惠"
      }, {
        min: 200,
        max: 299,
        discount: 0.8,
        text: "享8折优惠"
      }, {
        min: 300,
        max: 499,
        discount: 0.7,
        text: "享7折优惠"
      }, {
        min: 500,
        max: 99999,
        discount: 0.6,
        text: "享6折优惠"
      }];
      const range = priceRanges.find(range => this.customSize >= range.min && this.customSize <= range.max);
      if (range) {
        const basePrice = 3 * this.customSize;
        const discountedPrice = basePrice * range.discount;
        return `${range.text} ${discountedPrice.toFixed()}元起`;
      }
      return "样本数量不在有效范围内";
    },
    // 选中的套餐包
    activePackge() {
      const res = this.samplePackageList.filter(item => item.sampleSize == this.sampleSize)[0] || this.samplePackageList[3];
      return res;
    },
    // 样本类型和样本数量样式
    borderStyle() {
      return this.activeService !== "person-service" || this.showServiceList.length == 1;
    }
  },
  watch: {
    samplePackageList: {
      handler(val) {
        if (val) {
          this.customSize = val[3].sampleSize;
          const samplePackage = val.filter(item => item.sampleSize == this.sampleSize);
          if (!samplePackage.length) {
            this.customSize = this.sampleSize;
            this.$emit("update:sampleSize", this.customSize);
          }
        }
      },
      immediate: true
    }
  },
  mounted() {},
  methods: {
    // 切换样本服务
    changeService(item) {
      this.$emit("update:activeService", item.key);
    },
    // 切换样本数量
    changeCount(val, index) {
      this.$emit("update:sampleSize", index == 3 ? this.customSize : val);
    },
    // 切换到人工服务
    changeCheck() {
      message_box_default.a.confirm("特价样本/精准样本不支持更改要求，是否切换为人工服务？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        this.$emit("update:activeService", "person-service");
      }).catch(() => {});
    },
    // 查看样本介绍
    goSampleIntroduce() {
      window.open("/inner_collect_post", "_blank");
    },
    // 更改自定义数量
    changeCusromSize(event) {
      event.stopPropagation && event.stopPropagation();
      this.$emit("update:sampleSize", this.customSize);
    }
  }
});
// CONCATENATED MODULE: ./packages/sample-dialog/src/package-detail.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_package_detailvue_type_script_lang_js_ = (package_detailvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/sample-dialog/src/package-detail.vue?vue&type=style&index=0&id=3276abc8&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/sample-dialog/src/package-detail.vue?vue&type=style&index=0&id=3276abc8&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/sample-dialog/src/package-detail.vue






/* normalize component */

var package_detail_component = Object(componentNormalizer["a" /* default */])(
  src_package_detailvue_type_script_lang_js_,
  package_detailvue_type_template_id_3276abc8_scoped_true_render,
  package_detailvue_type_template_id_3276abc8_scoped_true_staticRenderFns,
  false,
  null,
  "3276abc8",
  null
  
)

/* harmony default export */ var package_detail = (package_detail_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/sample-dialog/src/index.vue?vue&type=script&lang=js&





/* harmony default export */ var srcvue_type_script_lang_js_ = ({
  name: "SampleDialog",
  components: {
    payment: payment,
    PackageDetail: package_detail
  },
  props: {
    // 是否展示弹窗，可以用v-model绑定
    visible: {
      type: Boolean,
      default: false
    },
    // 弹窗在body节点内的层级
    zIndex: {
      type: Number,
      default: 1000
    },
    // 确认弹窗支付的最高级样式,解决特出场景下继承父类层级关系无法解决弹窗位置的时候单独使用   confirmZindex > zIndex
    confirmZindex: {
      type: Number,
      default: null
    },
    // 项目ID
    projectId: {
      type: String,
      default: ""
    },
    // 项目类型是否为复杂项目
    isComplexProject: {
      type: Boolean,
      default: true
    },
    // 无复杂设置项目的题目数
    projectQuestionNum: {
      type: Number,
      default: 1
    },
    // 当前高亮样本服务类型
    activeService: {
      type: String,
      default: ""
    },
    // 购买的样本数量
    sampleSize: {
      type: Number,
      default: 50
    },
    // 分配服务顾问
    cunstomer: {
      type: [String, Number],
      default: 1
    },
    // 套餐购买成功后是否需要刷新当前页
    needReload: {
      type: Boolean,
      default: true
    },
    source: {
      type: String,
      default: ""
    }
  },
  data() {
    const appendUrl = "//s1.wenjuan.com/assets/images/business/sample-dialog/";
    return {
      appendUrl,
      coupons: [],
      // 选中版本的优惠券列表
      innerActiveService: "",
      // 选中的样本服务类型 人工/特价/精准
      innerSampleSize: 50 // 购买的样本数量
    };
  },

  computed: {
    // 项目类型  1:复杂项目 2：题目数小于等于15的非复杂项目 3：题目数大于15小于45的非复杂项目
    projectType() {
      if (this.isComplexProject || this.projectQuestionNum > 45) {
        this.$emit("update:activeService", "person-service");
        return "person-service";
      }
      if (this.projectQuestionNum < 16) {
        if (this.activeService !== "person-service") this.$emit("update:activeService", "sale-sample");
        return "sale-sample";
      }
      if (this.activeService !== "person-service") this.$emit("update:activeService", "accurate-sample");
      return "accurate-sample";
    },
    // 样本单价
    sampleUnitPrice() {
      return this.projectType == "accurate-sample" ? this.calculateSamplePrice(this.projectQuestionNum) : 3;
    },
    // 随机分配样本服务顾问
    onlineData() {
      const onlinePerson = {
        0: {
          qrCode: `https://s1.wenjuan.com/assets/images/business/sample-dialog/qrcode-whx.png`,
          phone: "181-1736-5784",
          name: "王老师",
          realname: "王慧心",
          register: "https://www.wenjuan.com/s/Qn2qqiM/"
        },
        1: {
          qrCode: `https://s1.wenjuan.com/assets/images/business/sample-dialog/qrcode-yzz.png`,
          phone: "159-2141-9095",
          name: "俞老师",
          realname: "俞知止",
          register: "https://www.wenjuan.com/s/BBZF7rc/#"
        }
      };
      return onlinePerson[this.cunstomer];
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.innerActiveService = this.activeService || this.projectType;
          this.innerSampleSize = this.sampleSize;
          this.source && window.zytrack && window.zytrack("custom", this.source);
          // 更新优惠券列表
          this.getCouponsAndPackage();
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getCouponsAndPackage();
  },
  methods: {
    // 在弹窗打开时候预先执行的逻辑
    initBefore() {},
    // 获取优惠券信息
    getCouponsAndPackage() {
      // 复杂项目无法使用优惠券
      if (this.projectType === "person-service") return;
      httpGetCouponList({
        sample_type: this.projectType === "sale-sample" ? 1 : 2
      }).then(res => {
        this.coupons = res.data.voc_info;
      }).catch(err => {
        if (typeof err === "object" && err.data.err_msg) {
          message_default()({
            message: err.data.err_msg,
            type: "warning"
          });
        } else {
          return Promise.reject(err);
        }
      });
    },
    // 精准样本服务根据题目数确定单价
    calculateSamplePrice(numQuestions) {
      const priceRanges = [{
        min: 15,
        max: 25,
        price: 3
      },
      // 题目数在(15,25]范围内，样本单价为3元
      {
        min: 25,
        max: 35,
        price: 6
      },
      // 题目数在(25,35]范围内，样本单价为6元
      {
        min: 35,
        max: 45,
        price: 9
      } // 题目数在(35,45]范围内，样本单价为9元
      ];

      // 查找匹配的范围
      const range = priceRanges.find(range => numQuestions > range.min && numQuestions <= range.max);
      return range ? range.price : 3;
    }
  },
  // 前瞻函数
  getEndNumber(str) {
    const lastNum = parseInt(str.match(/\d+(?=\D*$)/)[0]);
    if (lastNum % 2 === 0) return 1;
    return 0;
  }
});
// CONCATENATED MODULE: ./packages/sample-dialog/src/index.vue?vue&type=script&lang=js&
 /* harmony default export */ var sample_dialog_srcvue_type_script_lang_js_ = (srcvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js!./node_modules/css-loader/dist/cjs.js!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib??vue-loader-options!./packages/sample-dialog/src/index.vue?vue&type=style&index=0&id=7d912e35&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

// CONCATENATED MODULE: ./packages/sample-dialog/src/index.vue?vue&type=style&index=0&id=7d912e35&prod&lang=scss&scoped=true&

// CONCATENATED MODULE: ./packages/sample-dialog/src/index.vue






/* normalize component */

var src_component = Object(componentNormalizer["a" /* default */])(
  sample_dialog_srcvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  "7d912e35",
  null
  
)

/* harmony default export */ var src = (src_component.exports);
// CONCATENATED MODULE: ./packages/sample-dialog/index.js

src.install = function (Vue) {
  Vue.component(src.name, src);
};
/* harmony default export */ var sample_dialog = __webpack_exports__["default"] = (src);

/***/ }),

/***/ 26:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dropdown-menu");

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dropdown");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/message");

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/message-box.css");

/***/ }),

/***/ 39:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/tooltip.css");

/***/ }),

/***/ 42:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/input-number");

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/checkbox");

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dropdown-item.css");

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dropdown-menu.css");

/***/ }),

/***/ 57:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/dropdown.css");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/dialog");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@wenjuan/ui2/lib/theme-chalk/button.css");

/***/ })

/******/ })["default"];